var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-hover", {
    attrs: { "open-delay": "500" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ hover }) {
          return [
            _c(
              "v-navigation-drawer",
              {
                attrs: {
                  id: "appDrawer",
                  clipped: true,
                  "mini-variant": _vm.isMini && !hover,
                  fixed: "",
                  width: 285,
                  app: ""
                }
              },
              [
                _c(
                  "v-list",
                  { attrs: { dense: "", expand: "" } },
                  [
                    _vm._l(_vm.routes, function(item, i) {
                      return [
                        item.header
                          ? _c("v-subheader", { key: i }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.header) +
                                  "\n          "
                              )
                            ])
                          : item.divider
                          ? _c("v-divider", { key: i })
                          : _c(
                              "v-list-item",
                              {
                                key: i,
                                staticClass: "px-0",
                                attrs: {
                                  "active-class": "activeRoute",
                                  to: { name: item.name },
                                  ripple: "ripple"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.makeLoading(item.path)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    item.path === _vm.isLoading
                                      ? _c("v-progress-circular", {
                                          attrs: {
                                            indeterminate: "",
                                            size: "24"
                                          }
                                        })
                                      : _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [_vm._v(_vm._s(item.meta.icon))]
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "routeItem" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.generateRouteTitle(item.meta.title)
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ],
                              1
                            )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }